// Topbar — route label + ProfileMenu. Theme + Language controls live on
// the dedicated /settings page (apps/web/src/features/settings/).
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Icon } from '../ui/index.js';
import { NotificationBell, NotificationMessages } from '../features/notifications/index.js';
import { OnShiftToggle, ProfileMenu } from '../features/profile/index.js';
import { NAV_GROUPS, findActiveMenuMatch } from './menu.js';

export interface TopbarProps {
  onMobileMenu?: () => void;
}

export function Topbar({ onMobileMenu }: TopbarProps) {
  const { t } = useTranslation('shell');
  const { pathname } = useLocation();
  // WHY: Topbar carries section context (parent menu group); the page H1
  // carries page context. Standalone routes (no menu match) collapse to
  // `null` so the title element is omitted in render.
  const currentLabelKey = findActiveMenuMatch(pathname, NAV_GROUPS)?.group.label ?? null;

  return (
    <header
      style={{
        height: 'var(--topbar-h)',
        flex: 'none',
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        gap: 12,
        borderBottom: '1px solid var(--border-1)',
        background: 'var(--bg-1)',
        color: 'var(--fg-1)',
      }}
    >
      {onMobileMenu && (
        <button
          onClick={onMobileMenu}
          aria-label={t('topbar.menu')}
          style={{
            width: 32,
            height: 32,
            borderRadius: 'var(--r-1)',
            background: 'transparent',
            border: 'none',
            cursor: 'pointer',
            color: 'var(--fg-2)',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Icon name="layout-list" size={18} />
        </button>
      )}
      {currentLabelKey && (
        <div
          style={{
            fontSize: 14,
            fontWeight: 500,
            minWidth: 0,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {t(currentLabelKey)}
        </div>
      )}
      <div style={{ flex: 1 }} />
      <OnShiftToggle />
      <NotificationMessages />
      <NotificationBell />
      <ProfileMenu />
    </header>
  );
}
